export const DISABLE_BOOK_EXTENDED_TIMES = 'disable-book-extended-times';
const disableBookExtendedTimes = () => ({ type: DISABLE_BOOK_EXTENDED_TIMES });
export default disableBookExtendedTimes;
